import {Button, Flex, Text, VStack} from "@chakra-ui/react";

const SummaryTickets = ({attendees, ticketTypes, dwn, order, t}) => {
    const label = t('ticket.standard');

    const getTicketName = (ticketId) => {
        return ticketTypes?.find(t => (t.id) === (ticketId))?.name || label;
    };

    return <VStack spacing={4} align="stretch">
        {order?.tickets?.map((ticket, i) => (
            <Flex key={i} p={4} borderWidth={0} bgColor={'#F8F5F4'} gap="32px" flexDirection={"row"}
                  fontFamily="body" fontSize="18px" fontWeight="500" alignItems={"center"}>
                <Text fontFamily="body" fontSize="20px" fontWeight="700" color={'#7A1F35'}>
                    #{i+1}
                </Text>
                <Flex w={"full"} gap="32px">
                    <Flex flexDirection={"column"} flex="1">
                        <Text>
                            {t('order.summary.ticket.type')}
                        </Text>
                        <Text fontWeight="700">
                            {getTicketName(ticket.ticketId)}
                        </Text>
                    </Flex>
                    <Flex flexDirection={"column"} flex="1">
                        <Text>
                            {t('order.summary.ticket.name')}
                        </Text>
                        <Text fontWeight="700">
                            {ticket.name} {ticket.surName}
                        </Text>
                    </Flex>
                </Flex>
                {dwn && <Flex w={"full"} justifyContent={"flex-end"}>
                    <Button
                    borderRadius={'12px'}
                    color={'#FFFFFF'}
                    bgColor={'#7A1F35'}
                    py={'25px'}
                    px={'45px'}
                    onClick={() => dwn(ticket.ticketId, ticket.downloadToken)}>
                        {t('order.summary.ticket.download')}
                </Button>
                </Flex>}
            </Flex>
        ))}
    </VStack>;
}
export default SummaryTickets;
